module.exports = __webpack_public_path__ + "media/1x1/cm-c972441e.svg";